import { render, staticRenderFns } from "./trainee.math.singleTimestable.statistics.vue?vue&type=template&id=3b7a3776&scoped=true&"
import script from "./trainee.math.singleTimestable.statistics.vue?vue&type=script&lang=ts&"
export * from "./trainee.math.singleTimestable.statistics.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7a3776",
  null
  
)

export default component.exports